


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Search, Clock, Activity } from "lucide-react";
import logo from "../assets/logo.png";
import '../CSS/login.css';

function Login() {
  const navigate = useNavigate();
  const [cid, setCid] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!cid || cid.length !== 11) {
      setError('CID must be exactly 11 digits');
      return;
    }

    try {
      const response = await fetch(`https://q-less.onrender.com/api/patient/${cid}`);
      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('patientCID', cid);
        navigate('/dashboard');
      } else {
        setError(data.message || 'Patient not found. Please check your CID number.');
      }
    } catch (err) {
      setError('Failed to check status. Please try again.');
    }
  };

  return (
    <div className="patientpage-container">
      <header className="patientpage-header">
        <div className="patientpage-header-left">
          <ArrowLeft 
            size={20}
            className="patientpage-backicon" 
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          />
          <img src={logo} alt="Q-Less Logo" className="patientpage-logo" />
        </div>
      </header>

      <main className="patientpage-main">
        <div className="patientpage-card">
          <div className="patientpage-card-header">
            <Search size={38} className="patientpage-searchicon" />
            <h2>Patient Portal</h2>
            <p>Enter your CID number to check your queue status</p>
          </div>

          <form className="patientpage-form" onSubmit={handleSubmit}>
            <label htmlFor="cid">CID Number</label>
            <input
              id="cid"
              type="text"
              placeholder="Enter your CID Number"
              maxLength={11}
              value={cid}
              onChange={(e) => {
                setCid(e.target.value);
                setError('');
              }}
            />
            {error && <p className="error-text">{error}</p>}
            <button type="submit" className="patientpage-btn">Check Status</button>
          </form>

          <div className="patientpage-divider"></div>

          <div className="patientpage-info-row">
            <div className="patientpage-info">
              <Activity size={18} className="patientpage-info-icon" />
              <div>
                <h4>Real-time Updates</h4>
                <p>Get instant queue status</p>
              </div>
            </div>

            <div className="patientpage-info">
              <Clock size={18} className="patientpage-info-icon" />
              <div>
                <h4>No Waiting</h4>
                <p>Skip the physical queue</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="patientpage-footer">© 2025 Q-Less. All Rights Reserved.</footer>
    </div>
  );
}

export default Login;
